import { prepCardNamesData } from './prepCardData';

export const archiveCardNames = [
  { itemName: prepCardNamesData[0].itemName, extensions: ['pdf', 'mp3', ''] },
  { itemName: prepCardNamesData[1].itemName, extensions: ['pdf', 'mp3'] },
  { itemName: prepCardNamesData[2].itemName, extensions: ['pdf'] },
  { itemName: prepCardNamesData[3].itemName, extensions: ['pdf'] },
];
